export const createTeamoUrl = (userId, token) =>
  `http://teamo.ru/integration/mamba/?aid=${userId}&token=${token}`
